import moment from '@/assets/setups/moment'
import { useI18n } from 'vue-i18n'

export const tableTransactionDateParser = list => {
	const { t } = useI18n()

	const parsed = []
	let lastDateGroup = null
	let newDateGroup = {}

	if (list.length === 0) return parsed

	list.forEach(element => {
		var dateToCompare = new Date(element.rowDate).toDateString()
		if (lastDateGroup === null) { // we know this is the first iteration
			newDateGroup = { // we st art a new movement group
				groupDate: element.rowDate,
				groupElements: []
			}
			newDateGroup.groupElements.push(element) // we push the element to the group
			lastDateGroup = newDateGroup // we set the control group as new group
		} else if (new Date(lastDateGroup.groupDate).toDateString() === dateToCompare) {
			lastDateGroup.groupElements.push(element)
		} else {
			newDateGroup = {
				groupDate: element.rowDate,
				groupElements: []
			}
			newDateGroup.groupElements.push(element)

			if (isToday(lastDateGroup.groupDate)) {
				lastDateGroup.groupDate = moment.utc(lastDateGroup.groupDate).format(`[${t('datesHelpers.today')}], D MMMM`)
			} else if (isYesterday(lastDateGroup.groupDate)) {
				lastDateGroup.groupDate = moment.utc(lastDateGroup.groupDate).format(`[${t('datesHelpers.yesterday')}], D MMMM`)
			} else {
				lastDateGroup.groupDate = moment.utc(lastDateGroup.groupDate).format('D MMMM')
			}

			parsed.push(lastDateGroup)
			lastDateGroup = newDateGroup
		}
	})

	if (isToday(lastDateGroup.groupDate)) {
		lastDateGroup.groupDate = moment.utc(lastDateGroup.groupDate).format(`[${t('datesHelpers.today')}], D MMMM`)
	} else if (isYesterday(lastDateGroup.groupDate)) {
		lastDateGroup.groupDate = moment.utc(lastDateGroup.groupDate).format(`[${t('datesHelpers.yesterday')}], D MMMM`)
	} else {
		lastDateGroup.groupDate = moment.utc(lastDateGroup.groupDate).format('D MMMM')
	}

	parsed.push(lastDateGroup)
	return parsed
}

export const tableTransactionDateByMonthParser = list => {
	const { t } = useI18n()

	const parsed = []
	let lastDateGroup = null
	let newDateGroup = {}

	if (list.length === 0) return parsed

	list.forEach(element => {
		var dateToCompare = moment.utc(element.rowDate).format('MMMM YYYY')

		/* we know this is the first iteration */
		if (lastDateGroup === null) {
			/* we st art a new movement group */
			newDateGroup = { groupDate: element.rowDate, groupElements: [] }
			/* we push the element to the group */
			newDateGroup.groupElements.push(element)

			lastDateGroup = newDateGroup // we set the control group as new group
		/* Validating if its same month */
		} else if (moment.utc(lastDateGroup.groupDate).format('MMMM YYYY') === dateToCompare) {
			lastDateGroup.groupElements.push(element)
		} else {
			newDateGroup = {
				groupDate: element.rowDate,
				groupElements: []
			}
			newDateGroup.groupElements.push(element)

			lastDateGroup.groupDate = moment.utc(lastDateGroup.groupDate).format('MMMM YYYY')

			parsed.push(lastDateGroup)
			lastDateGroup = newDateGroup
		}
	})

	lastDateGroup.groupDate = moment.utc(lastDateGroup.groupDate).format('MMMM YYYY')

	parsed.push(lastDateGroup)
	return parsed
}

export const isToday = date => {
	const today = new Date()
	const temp = new Date(date)
	return temp.getDate() === today.getDate() && temp.getMonth() === today.getMonth() && temp.getFullYear() === today.getFullYear()
}

export const isYesterday = date => {
	const yesterday = new Date(moment().subtract(1, 'days'))
	const temp = new Date(date)
	return temp.getDate() === yesterday.getDate() && temp.getMonth() === yesterday.getMonth() && temp.getFullYear() === yesterday.getFullYear()
}

/** Receives tableData and alters radio column value for that row
@tableData { Array }
@rowId { Id } - new row selected Id
@removeRadio { Boolean } - removes radio selected status
@return { Array } - tableData modified
*/
export const parseToSelectRowRadio = (tableData, rowId, removeRadio) => {
	return tableData.map(row => {
		const tempRowId = row.find(column => column.dataAttr === 'id').value

		return row.map(column => {
			/*  If it's a radio cell, we will change radio status */
			if (column.type === 'radio') {
                let radioValue = column.value
                if (removeRadio && rowId === tempRowId) {
                    radioValue = typeof column.value === 'boolean' ? false : { ...column.value, selected: false }
                }
                if (!removeRadio) {
                    radioValue = typeof column.value === 'boolean' ? rowId === tempRowId : { ...column.value, selected: rowId === tempRowId && !column.value.disabled }
                }
                return {
                    ...column,
                    value: radioValue
                }
            }
			/* Returns any other column as it is */
			return column
		})
	})
}

/** Receives tableData and alters radio column value for that row
@tableData { Array }
@rowId { Id } - new row selected Id
@return { Array } - tableData modified
*/
export const parseToDisabledEnabledRowRadio = (tableData, rowId, canBeUsedAsDefault) => {
	return tableData.map(row => {
		const tempRowId = row.find(column => column.dataAttr === 'id').value

		return row.map(column => {
			/*  If it's a radio cell, we will change radio status */
			if (column.type === 'radio' && rowId === tempRowId) {
                return {
                    ...column,
                    value: { ...column.value, disabled: !column.value.disabled }
                }
            }
			/* Returns any other column as it is */
			return column
		})
	})
}

/** Receives tableData and alters switch column value for that row
@tableData { Array }
@rowId { Id } - new row selected Id
@return { Array } - tableData modified
*/
export const parseToSelectRowSwitch = (tableData, rowId) => {
	return tableData.map(row => {
		const tempRowId = row.find(column => column.dataAttr === 'id').value

		return row.map(column => {
			/*  If it's a switch cell, we will change switch status */
			if (column.type === 'switch' && rowId === tempRowId) {
				return {
					...column,
					value: typeof column.value === 'boolean' ? !column.value : { ...column.value, isActive: !column.value.isActive }
				}
			}
			/* Returns any other column as it is */
			return column
		})
	})
}

/** Receives tableData and alters dropdown column value for that row
@tableData { Array }
@$event {Object} - object with:
	- rowId
	- dropdownIdentifier
	- selectedOption
@return { Array } - tableData modified
*/
export const parseToSelectOptionInDropdown = (tableData, $event) => {
	return tableData.map(row => {
		if (row.find(obj => obj.dataAttr === 'id').value !== $event.rowId) return row

		return row.map(column => {
			if (column.dataAttr !== $event.dropdownIdentifier) return column
			return {
				...column,
				value: { ...column.value, selectedOption: $event.selectedOption }
			}
		})
	})
}

/** Receives tableData and alters input column value for that row
@tableData { Array }
@$event {Object} - object with:
	- rowId
	- inputIdentifier
	- inputValue
@return { Array } - tableData modified
*/
export const parseToChangeInputValue = (tableData, $event) => {
	return tableData.map(row => {
		if (row.find(obj => obj.dataAttr === 'id').value !== $event.rowId) return row

		return row.map(column => {
			if (column.dataAttr !== $event.inputIdentifier) return column
			return {
				...column,
				value: { ...column.value, inputValue: $event.inputValue }
			}
		})
	})
}

/* ***********************************************
*                                                *
*                    SORT LOGIC                  *
*                                                *
*************************************************/
/** Receives tableData and alters input column value for that row
@tableData { Array }
@$event {Object} - object with:
	- direction
	- columnIdentifier (dataAttr)
@return { Array } - tableData sorted
*/
export const sortTableData = (tableData, $event) => {
	return $event.direction === 'Asc' ? sortAsc(tableData, $event.sortBy) : sortDesc(tableData, $event.sortBy)
}

export const getRowSorterColumnValue = (row, sorter) => {
	const temp = row.find(col => col.dataAttr === sorter)

	if (typeof temp.value === 'object') {
		switch (temp.type) {
			case 'status':
				return temp.value.icon + (temp.value.text || 'a') // in case there's no text to sort, we will add an 'a' so its the first/last thing when sorting
			default:
				if (sorter === 'date') return new Date(temp.value.rawDate || temp.value.content)
				if (sorter === 'genericDestination') return !temp.rawValue ? 'a' : `a${temp.rawValue}`
				return temp.value.sortByValue || temp.value.content || 'a'
		}
	} else {
		/* For some sorters we will need to use 0 as empty value to help sorting tables */
		if (sorter === 'phoneNumber') return !temp.value || temp.value === '-' ? 0 : temp.value
		if (sorter === 'date') return new Date(temp.value.rawDate || temp.value.content)
		if (sorter === 'genericDestination') return !temp.rawValue ? 'a' : `a${temp.rawValue}`
		return temp.value === '-' ? 'a' : (temp.value || 'a')
	}
}

export const sortAsc = (array, sorter) => {
	array.sort((a, b) => {
		if (isNaN(getRowSorterColumnValue(a, sorter)) && sorter !== 'date') {
			if (getRowSorterColumnValue(a, sorter).toString().toLowerCase() > getRowSorterColumnValue(b, sorter).toString().toLowerCase()) return 1
			if (getRowSorterColumnValue(a, sorter).toString().toLowerCase() < getRowSorterColumnValue(b, sorter).toString().toLowerCase()) return -1
			return 0
		} else {
			return getRowSorterColumnValue(a, sorter) - getRowSorterColumnValue(b, sorter)
		}
	})
	return array
}

export const sortDesc = (array, sorter) => {
	array.sort((a, b) => {
		if (isNaN(getRowSorterColumnValue(a, sorter)) && sorter !== 'date') {
			if (getRowSorterColumnValue(a, sorter).toString().toLowerCase() < getRowSorterColumnValue(b, sorter).toString().toLowerCase()) return 1
			if (getRowSorterColumnValue(a, sorter).toString().toLowerCase() > getRowSorterColumnValue(b, sorter).toString().toLowerCase()) return -1
			return 0
		} else {
			return getRowSorterColumnValue(b, sorter) - getRowSorterColumnValue(a, sorter)
		}
	})

	return array
}
